// extracted by mini-css-extract-plugin
module.exports = {"Spacer":"Spacer__Spacer___mCvPQ"};